import {useState, useEffect, useCallback} from 'react';

const STORAGE_KEY = 'koenig-articles';

function getArticlesFromStorage() {
    const articlesStr = localStorage.getItem(STORAGE_KEY);
    return articlesStr ? JSON.parse(articlesStr) : [];
}

function updateArticlesInStorage(articlesArr = []) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(articlesArr));
}

export const useArticles = () => {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        setArticles(getArticlesFromStorage());
    }, []);

    // Function to refresh articles from storage (memoized to prevent infinite loops)
    const refreshArticles = useCallback(() => {
        setArticles(getArticlesFromStorage());
    }, []);

    function saveArticle({id, title, content, editorState, createdAt, updatedAt}) {
        const allArticles = getArticlesFromStorage();
        const articleIndex = allArticles.findIndex(item => item.id === id);
        
        const article = {
            id: id || `article-${Date.now()}`,
            title: title || 'Untitled Article',
            content: content || '',
            editorState: editorState || null,
            createdAt: createdAt || new Date().toISOString(),
            updatedAt: updatedAt || new Date().toISOString()
        };

        if (articleIndex === -1) {
            allArticles.unshift(article); // Add to beginning
        } else {
            allArticles[articleIndex] = {...allArticles[articleIndex], ...article, updatedAt: new Date().toISOString()};
        }

        setArticles(allArticles);
        updateArticlesInStorage(allArticles);
        return article;
    }

    function deleteArticle(articleId) {
        const allArticles = getArticlesFromStorage();
        const updatedArticles = allArticles.filter(item => item.id !== articleId);
        setArticles(updatedArticles);
        updateArticlesInStorage(updatedArticles);
    }

    function getArticle(articleId) {
        const allArticles = getArticlesFromStorage();
        return allArticles.find(item => item.id === articleId);
    }

    return {
        articles,
        saveArticle,
        deleteArticle,
        getArticle,
        refreshArticles
    };
};

